<ul class="tags">
  <li>
    <span *ngFor="let tag of tags">
      <button [ngClass]="tagClass(tag)" (click)="onTagClick($event, tag)">

        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getVersionToolTip(tag)"
          [theme]="'dark'"
        >
          {{tag.trim()}}
        </particle-dynamic-tooltip-container>


        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getMasterScenarioToolTip(tag)"
          [theme]="'dark'"
          [ngClass]="{ 'hide': getMasterScenarioToolTip(tag) === '' }"
        >
          <i class="fa-solid fa-star m-l-4"></i>
        </particle-dynamic-tooltip-container>


        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getScheduleUpdateTooltip(tag)"
          [theme]="'dark'"
          [ngClass]="{ 'hide': getScheduleUpdateTooltip(tag) === '' }"
        >
          <i class="fa-regular fa-clock m-l-4"></i>
        </particle-dynamic-tooltip-container>


        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getIncompleteTooltip(tag)"
          [theme]="'dark'"
          [ngClass]="{ 'hide': getIncompleteTooltip(tag) === '' }"
        >
          <i class="fa-solid fa-circle-minus m-l-4"></i>
        </particle-dynamic-tooltip-container>


        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getTemplateUpdateVersionTooltip(tag)"
          [theme]="'dark'"
          [ngClass]="{ 'hide': getTemplateUpdateVersionTooltip(tag) === '' }"
        >
          <i class="fa-solid fa-rotate m-l-4"></i>
        </particle-dynamic-tooltip-container>


        <particle-dynamic-tooltip-container
          [openOption]="'hover'"
          [htmlElement]="getLegacyTemplateVersionTooltip(tag)"
          [theme]="'dark'"
          [ngClass]="{ 'hide': getLegacyTemplateVersionTooltip(tag) === '' }"
        >
          <i class="fa fa-exclamation-triangle m-l-4"></i>
        </particle-dynamic-tooltip-container>


      </button>
    </span>
  </li>

  <li
    *ngIf="
      data.cells['Tooltip'] && data.cells['Tooltip'].value == 'Archived' && data.cells['ViewType'] && data.cells['ViewType'].value != 'ListView'
    "
    matTooltip="{{ data.cells['Tooltip'].displayText }}"
    class="archivedTooltip"
  >
    <i class="fa-solid fa-box-archive"></i>
  </li>

  <li *ngIf="isLocked">
    <particle-dynamic-tooltip-container
      class="w-n-16"
      [openOption]="'hover'"
      [htmlElement]="lockedScenarioMessage"
      [width]="320"
      [theme]="'dark'"
    >
      <i class="fa-solid fa-lock"></i>
    </particle-dynamic-tooltip-container>
  </li>
</ul>
